export default __webpack_public_path__ + "66b2a969a29a4f232f83ed52caa43869.png";